import shortid from 'shortid';

const createAmazonUpload = (number, file, onProgress, onComplete, onError) => {
    const host = 'https://s3.amazonaws.com/molab/';
    const fileId = `molab/wt/${number}/${shortid.generate()}/${file.name}`;
    const fileLocation = host + fileId;

    const formData = new FormData();
    formData.append('key', fileId);
    formData.append('AWSAccessKeyId', 'AKIAI2XJZFPKCC3PQKXA');
    formData.append('acl', 'public-read');
    formData.append('policy', 'CnsgImV4cGlyYXRpb24iOiAiMjAzMC0xMi0wMVQxMjowMDowMC4wMDBaIiwKICAiY29uZGl0aW9ucyI6IFsKICAgIHsiYnVja2V0IjogIm1vbGFiIiB9LAogICAgWyJzdGFydHMtd2l0aCIsICIka2V5IiwgIm1vbGFiLyJdLAogICAgeyJhY2wiOiAicHVibGljLXJlYWQiIH0KICBdCn0K');
    formData.append('signature', 'YdhIXcMzwrjsqKW4e0Vs7mmz4pk=');
    formData.append('file', file);
    const xhr = new XMLHttpRequest();
    xhr.open('POST', host);
    xhr.upload.addEventListener('progress', e => {
        if (e.lengthComputable) {
            const percent = Math.round(100 * e.loaded / e.total);
            console.log(percent);
            onProgress(fileLocation, percent);
        }
    });
    xhr.addEventListener('load', () => onComplete(fileLocation));
    xhr.addEventListener('error', () => onError(fileLocation));
    xhr.send(formData);

    return {
        location: fileLocation,
        abort: () => xhr.abort(),
    };
};

export default createAmazonUpload;


// WEBPACK FOOTER //
// ./src/utils/createAmazonUpload.js